import React, { ReactNode } from 'react';
import { PageTemplate } from '../../../models/templates/pageTemplate';
import ComponentList from '../../molecules/component-list/component-list';
import SidebarNavigation from '../../molecules/sidebar-navigation/sidebar-navigation';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';

export type Props = {
  template: PageTemplate;
  pagePath?: string;
  children?: ReactNode;
  showExclusions?: Boolean;
  locales?: string[];
  currentLocale?: string;
  application?: string;
  applicationURL?: string;
  router?: AppRouterInstance;
};

export default function ContentfulPage({
  template,
  children,
  showExclusions,
  pagePath,
  locales,
  currentLocale,
  application,
  applicationURL,
  router,
}: Props) {
  const sidebarNavProps = template?.brandSidebarNavigation
    ? template?.brandSidebarNavigation
    : template?.sidebarNavigation;

  return (
    <div
      className={
        template?.sidebarNavigation || template?.brandSidebarNavigation
          ? 'custom-page-template'
          : 'overflow-x-hidden'
      }
    >
      {template.exclusionReasons.map((reason) => {
        if (!showExclusions) {
          return null;
        }

        return (
          <div key={`${reason.field}${reason.field}${reason.reason}`} className='col-lg-9'>
            <p>
              {reason.entityType} - {reason.entity} - {reason.field} - {reason.reason}
            </p>
          </div>
        );
      })}
      {children ? children : null}
      <div className='container'>
        {template?.sidebarNavigation || template?.brandSidebarNavigation ? (
          <div className='row'>
            <div className='col-lg-3 px-0 px-lg-3'>
              <SidebarNavigation
                sidebarNavigationProps={sidebarNavProps}
                sidebarBrandColor={template?.content[0].appSettings.branding.primaryColor}
                b2cFlag={template?.content[0].appSettings.b2cFlag}
                pagePath={pagePath}
                locales={locales}
              />
            </div>
            <div className='col-lg-9 py-lg-4 py-0'>
              <ComponentList
                components={template.content}
                isSidebarNavigation={true}
                application={application}
                applicationURL={applicationURL}
                router={router}
                currentLocale={currentLocale}
                pathname={pagePath}
              />
            </div>
          </div>
        ) : (
          <ComponentList
            components={template.content}
            application={application}
            applicationURL={applicationURL}
            router={router}
            currentLocale={currentLocale}
            pathname={pagePath}
          />
        )}
      </div>
    </div>
  );
}
